import { render, staticRenderFns } from "./documents.valueAddedTax.vue?vue&type=template&id=3d733990&scoped=true"
import script from "./documents.valueAddedTax.vue?vue&type=script&lang=js"
export * from "./documents.valueAddedTax.vue?vue&type=script&lang=js"
import style0 from "./documents.valueAddedTax.vue?vue&type=style&index=0&id=3d733990&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d733990",
  null
  
)

export default component.exports